var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMensagem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mensagem"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.08329 16.2839H6.66663C3.33329 16.2839 1.66663 15.4505 1.66663 11.2839V7.11719C1.66663 3.78385 3.33329 2.11719 6.66663 2.11719H13.3333C16.6666 2.11719 18.3333 3.78385 18.3333 7.11719V11.2839C18.3333 14.6172 16.6666 16.2839 13.3333 16.2839H12.9166C12.6583 16.2839 12.4083 16.4089 12.25 16.6172L11 18.2839C10.45 19.0172 9.54996 19.0172 8.99996 18.2839L7.74996 16.6172C7.61663 16.4339 7.30829 16.2839 7.08329 16.2839Z",
    stroke: "#84818A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.33 9.61719H13.3383M9.99581 9.61719H10.0041M6.66248 9.61719H6.66914",
    stroke: "#84818A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMensagem);
export default __webpack_public_path__ + "static/media/Mensagem.1ec89e058b4194e46b915ff26b9485df.svg";
export { ForwardRef as ReactComponent };